import { render, staticRenderFns } from "./methodologies.vue?vue&type=template&id=be51a56e&scoped=true&"
import script from "./methodologies.vue?vue&type=script&lang=js&"
export * from "./methodologies.vue?vue&type=script&lang=js&"
import style0 from "./methodologies.vue?vue&type=style&index=0&id=be51a56e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be51a56e",
  null
  
)

export default component.exports